import { useSelector } from "react-redux";
import { Navigate } from "react-router";

export default function RestrictedRoute({ children }) {
    const authState= useSelector((state)=>state?.auth)
  return (authState?.companyId == 0)?children: <Navigate to="/" replace /> ;
}
